import React from 'react';
import Style from './style.sass';

const ImageFile = (props) => {
  return (
    <React.Fragment>
      <input className={Style.Filter__imageFile} type='file' accept='.jpg, .png'onChange={props.onChange}/>
    </React.Fragment>
  )
}

export default ImageFile;